class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.flkty = null;
    this.sliderButtons = null;
  }

  connectedCallback() {
    this.slider = this.querySelector("[data-custom-slider]");
    this.sliderButtons = this.querySelectorAll("[data-custom-slider-button]");

    this.sliderButtons.forEach((button) => {
      button.addEventListener("click", this.handleButtonClick.bind(this));
    });
  }

  handleButtonClick(event) {
    const flkty = Flickity.data(this.slider);
    const type = event.currentTarget.dataset.type;
    if (type === "prev") {
      flkty.previous();
    } else if (type === "next") {
      flkty.next();
    }
  }
}

customElements.define("custom-slider", CustomSlider);
